import React from "react";
import { styled } from "@mui/system";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import MuiLink from "@mui/material/Link";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Link as RouterLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "swiper/css";

import Footer from "../Components/Footer/Footer";
import MuiReactSlider from "../Components/Slider/Slider";
import ReviewSection from "../Components/GoogleSlide/GoogleSlide";
import useMetaTracking from "../hooks/useMetaTracking";

const HEADER_HEIGHT = 80;

const StyledButton = styled(Button)(() => ({
  backgroundColor: "#00aae3",
  color: "#fff",
  fontWeight: "bold",
  marginTop: 30,
  padding: "10px 40px",
  textTransform: "none",
  borderRadius: 30,
  position: "relative",
  overflow: "hidden",
  transition: "background-color 0.3s ease",

  "&:hover": {
    backgroundColor: "#33BBE8",
  },
  "& .chevron-icon": {
    position: "absolute",
    right: "-20px",
    opacity: 0,
    transition: "all 0.4s ease",
  },
  "&:hover .chevron-icon": {
    right: "12px",
    opacity: 1,
  },
}));

const Home = () => {
  useMetaTracking("ViewContent", {
    content_name: "Home Page",
    content_category: "Home Page",
    content_ids: ["home_page"],
    content_type: "home_page",
  });

  return (
    <>
        <Helmet>
          <title>Home | Đông Hưng Viên Bakery</title>
          <meta
            name="description"
            content="Explore our authentic Vietnamese menu, including traditional and vegan bánh mì, vegan pastries, drinks, and more."
          />
          <meta
            name="keywords"
            content="Vietnamese food, vegan Vietnamese food, vegan bánh mì, Vietnamese bakery"
          />
          <meta name="author" content="donghungvienbakery" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
          <link
            rel="canonical"
            href="https://donghungvienbakery.com/"
          />
        </Helmet>

      {/* Keep the slider below the fixed navbar. */}
      <Box
        sx={{
          pt: `${HEADER_HEIGHT}px`,
        }}
      >
        <MuiReactSlider />
      </Box>

      {/* Announcement Banner */}
      <Box sx={{ background: "#141414 !important" }}>
        <Box sx={{ maxWidth: 1240, width: "90%", mx: "auto", py: 6, textAlign: "center" }}>
          <Typography variant="h5" sx={{ fontWeight: "bold", color: "#fff" }}>
            Vegan-friendly Vietnamese bakery serving both traditional & vegan bánh mì, pastries, desserts and coffee.
          </Typography>
        </Box>
      </Box>

      {/* Contact / Visit Us */}
      <Box>
        <Grid container>
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                background: "#283341 !important",
                p: 2,
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontSize: 30,
                  my: 2,
                  color: "#fff",
                  fontWeight: 500,
                }}
              >
                COME VISIT US
              </Typography>
              <MuiLink
                component={RouterLink}
                to="/contact"
                underline="none"
              >
                <StyledButton sx={{ fontSize: 16 }}>
                  Contact Us
                  <ChevronRightIcon className="chevron-icon" />
                </StyledButton>
              </MuiLink>
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* Google Reviews */}
      <ReviewSection />

      {/* Footer */}
      <Footer />
    </>
  );
}

export default Home;
